import React from "react";
import { useTranslation } from "react-i18next";
import { NewQuoteOrganism } from "../../organisms";

export const NewQuotePage: React.FC = () => {
  const { t } = useTranslation();

  return <NewQuoteOrganism title={t("NewQuotePageTitle")} />;
};
